// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{box-sizing:border-box !important;margin:0;padding:0}`, "",{"version":3,"sources":["webpack://./src/style.scss"],"names":[],"mappings":"AAAA,EACE,gCAAA,CACA,QAAA,CACA,SAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
